// Modules
import React, { useContext } from "react";
import PropTypes from "prop-types";

// Context
import ApiContext from "../../../contexts/ApiContext";

// Assets
import LogoPrimary from "../../../assets/img/svg/LogoPrimary";
import LogoSecondary from "../../../assets/img/svg/LogoSecondary";

const LogoLink = (props) => {
	const {
		clssName,
		type,
	} = props;
	const { isMobile, isTablet } = useContext(ApiContext);

	return (
		<a
			className={clssName}
			href="https://www.bevouac.com/"
			style={isMobile === true || isTablet === true
				? { bottom: ".3vh", marginRight: "1vh" }
				: {}}
		>
			{type === "primary"
				? <LogoPrimary />
				: <LogoSecondary />}
		</a>
	);
};

LogoLink.propTypes = {
	clssName: PropTypes.string,
	type: PropTypes.oneOf(["primary", "secondary"]),
};

LogoLink.defaultProps = {
	clssName: "",
	type: "primary",
};

export default LogoLink;
